<template>
  <div class="hello">
    <GlobalHeader style="position: absolute;" :activeIndex="activeIndex"/>
    <el-main>
      <div
          style="position: fixed;z-index: 111; background: #fff;width: calc(100% - 185px);  height: calc(100vh - 50px);overflow: auto;">
        <div class="edit">
          <el-tooltip class="item" effect="dark" content="选择年" placement="top-start">
            <el-date-picker v-model="value0" type="year" placeholder="选择年" style="width: 137px;margin-left: 6px;"
                            @change="getList"
                            size="mini" format="yyyy-MM-dd" range-separator="" value-format="timestamp">
            </el-date-picker>
          </el-tooltip>
          <span v-if="this.role != 8" style="margin-left: 5px" @click="excelEvt">EXCEL</span>
        </div>
        <div class="tbale_one">
          <table v-for="(item, index) in tableData" :key="index" class="table_two">
            <thead class="order">
            <tr style="background-color: #fff;">
              <th>{{ item.name }}</th>
              <th>总计</th>
              <th>1月</th>
              <th>2月</th>
              <th>3月</th>
              <th>4月</th>
              <th>5月</th>
              <th>6月</th>
              <th>7月</th>
              <th>8月</th>
              <th>9月</th>
              <th>10月</th>
              <th>11月</th>
              <th>12月</th>
            </tr>
            </thead>
            <tbody>
            <tbody>

            <tr class="">
              <td class="">每月产值成本比</td>
              <td class="one" :style="{ color: item.div_emp_total == 0 ? '#e6f5ef' : ' #000' }">{{
                  item.div_emp_total
                }}%
              </td>
              <td v-for="(val, valIndex) in item.div_emp" :key="valIndex" :style="{color:val ==0 ? '#fff' :' #000'}">
                {{ val }}
              </td>
            </tr>
            <tr class="">
              <td>每月产值</td>
              <td class="one" :style="{ color: array_sum(item.division) == 0 ? '#e6f5ef' : ' #000' }">
                {{ array_sum(item.division) }}
              </td>
              <td v-for="(val, valIndex) in item.division" :key="valIndex"
                  :style="{ color: val == 0 ? '#fff' : ' #000' }">
                {{ val }}
              </td>
            </tr>
            <tr class="">
              <td>每月回款</td>
              <td class="one" :style="{ color: array_sum(item.backed) == 0 ? '#e6f5ef' : ' #000' }">
                {{ array_sum(item.backed) }}
              </td>
              <td v-for="(val, valIndex) in item.backed" :key="valIndex"
                  :style="{ color: val == 0 ? '#fff' : ' #000' }">
                {{ val }}
              </td>
            </tr>
            <tr>
              <td>每月总雇佣成本</td>
              <td class="one" :style="{ color: array_sum(item.employment)  == 0 ? '#e6f5ef' : ' #000' }">
                {{ array_sum(item.employment) }}
              </td>
              <td v-for="(val, valIndex) in item.employment" :key="valIndex"
                  :style="{ color: val == 0 ? '#fff' : ' #000' }">
                {{ val }}
              </td>
            </tr>
            <tr>
              <td><span v-html="blank"></span>底薪</td>
              <td class="one" :style="{ color: array_sum(item.allowance)  == 0 ? '#e6f5ef' : ' #000' }">
                {{ array_sum(item.allowance) }}
              </td>
              <td v-for="(val, valIndex) in item.allowance" :key="valIndex"
                  :style="{ color: val == 0 ? '#fff' : ' #000' }">
                {{ val }}
              </td>
            </tr>
            <tr>
              <td><span v-html="blank"></span>社保公司部分</td>
              <td class="one" :style="{ color: array_sum(item.security_payment)  == 0 ? '#e6f5ef' : ' #000' }">
                {{ array_sum(item.security_payment) }}
              </td>
              <td v-for="(val, valIndex) in item.security_payment" :key="valIndex"
                  :style="{ color: val == 0 ? '#fff' : ' #000' }">
                {{ val }}
              </td>
            </tr>
            <tr>
              <td><span v-html="blank"></span>提成</td>
              <td class="one" :style="{ color: array_sum(item.commission)  == 0 ? '#e6f5ef' : ' #000' }">
                {{ array_sum(item.commission) }}
              </td>
              <td v-for="(val, valIndex) in item.commission" :key="valIndex"
                  :style="{ color: val == 0 ? '#fff' : ' #000' }">
                {{ val }}
              </td>
            </tr>
            <tr>
              <td><span v-html="blank"></span>加班打车</td>
              <td :style="{ color: '#000' }"></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td><span v-html="blank"></span>素材购买</td>
              <td :style="{ color: '#000' }"></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>每月总工作量</td>
              <td class="one" :style="{ color: array_sum(item.quantities) == 0 ? '#e6f5ef' : ' #000' }">
                {{ array_sum(item.quantities) }}
              </td>
              <td v-for="(val, valIndex) in item.quantities" :key="valIndex"
                  :style="{ color: val == 0 ? '#fff' : ' #000' }">
                {{ val }}
              </td>
            </tr>
            <tr>
              <td>单位工作量成本</td>
              <td class="one" :style="{ color: item.unit_division_total == 0 ? '#e6f5ef' : ' #000' }">
                {{ item.unit_employees_total }}
              </td>
              <td v-for="(val, valIndex) in item.unit_employees" :key="valIndex"
                  :style="{ color: val == 0 ? '#fff' : ' #000' }">
                {{ val }}
              </td>
            </tr>
            <tr>
              <td>单位工作量产值</td>
              <td class="one" :style="{ color: item.unit_division_total == 0 ? '#e6f5ef' : ' #000' }">
                {{ item.unit_division_total }}
              </td>
              <td v-for="(val, valIndex) in item.unit_division" :key="valIndex"
                  :style="{ color: val == 0 ? '#fff' : ' #000' }">
                {{ val }}
              </td>
            </tr>
            <tr>
              <td>人数</td>
              <td class="one" :style="{ color: array_sum(item.emp_num) == 0 ? '#e6f5ef' : ' #000' }">
                {{ array_sum(item.emp_num) }}
              </td>
              <td v-for="(val, valIndex) in item.emp_num" :key="valIndex"
                  :style="{ color: val == 0 ? '#fff' : ' #000' }">
                {{ val }}
              </td>
            </tr>
            <tr>
              <td>人均月产值</td>
              <td class="one" :style="{ color: item.staff_avg == 0 ? '#e6f5ef' : ' #000' }">{{ item.staff_avg }}</td>
              <td v-for="(val, valIndex) in item.staff_avg_division" :key="valIndex"
                  :style="{ color: val == 0 ? '#fff' : ' #000' }">
                {{ val }}
              </td>
            </tr>
            </tbody>
            </tbody>
          </table>
        </div>
        <div style="height: 50px;"></div>
      </div>
    </el-main>
  </div>
</template>

<script>
import GlobalHeader from '@/components/GlobalHeader.vue'
import {AnnualApi,} from "@/api/salary/index.js"


export default {
  components: {
    GlobalHeader
  },
  computed: {},
  data() {

    return {
      blank: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
      loading: false,
      activeIndex: "4-3",
      tableData: [],
      value0: '',
      loadedDataCount: 0,// 已加载的数据数量
      role: localStorage.getItem("role"),
    };
  },
  created() {

  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);

    // 初始化加载数据
    this.loadData();
  },
  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    excelEvt() {
      if (this.role == 8) {
        return;
      }
      var income_time_start = Math.floor(this.value0 / 1000);
      let data = {
        start: income_time_start,
        excel: 1,
      }
      this.loading = true
      let genExcel = false;
      if (genExcel == false) {
        AnnualApi(data).then((res) => {
          this.loading = false
          window.location.href = res
          genExcel = true
        });
      } else if (genExcel == true) {
        alert('正在生成数据请勿重复请求')
      }
    },
    handleScroll() {
      // 判断是否滚动到页面底部
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
        // 加载数据
        this.loadData();
      }
    },
    loadData() {
      // 发送请求获取数据
      AnnualApi().then(res => {
        const newData = res.data.data;

        // 将获取到的数据追加到已有的数据列表中
        this.tableData = [...this.tableData, ...newData];

        // 更新已加载的数据数量
        this.loadedDataCount += newData.length;
      });
    },

    //排序
    array_sum: function (obj) {
      let sum = 0;
      for (let key in obj) {
        sum += parseInt(obj[key])
      }
      return sum;
    },
    sum_avg: function (a, b) {
      b = Array.from(b).reduce((sum, value) => sum + value, 0);
      a = Array.from(a).reduce((sum, value) => sum + value, 0);
      if (b !== 0) {
        return a / b;
      }
      return 0;
    },

    getList() {
      let date4 = {
        start: this.value0[0],
        end: this.value0[1],
      };
      var income_time_start = Math.floor(this.value0 / 1000);
      let data = {
        start: income_time_start
      }
      AnnualApi(data).then(res => {
        this.tableData = res.data.data
      })
    },


  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import url("../../../style/Media_Query.less");

.el-main {
  left: 185px;
  /* 与左侧项目管理列表的宽度保持一致 */
  padding: 0px;
  /* 添加一些内边距，使内容不紧贴在边缘 */
  top: 60px;
  position: relative;
}


.tbale_one {
  font-size: 12px;
}

.edit {
  // width: 1000px;
  height: 35px;
  display: flex;

  div {
    width: 137px;
    height: 26px;
    cursor: pointer;
  }

  .el-input {
    width: 137px;
    height: 26px;
    line-height: 26px;
    cursor: pointer;
    width: 137px;
    margin-left: 5px;
  }

  span {
    width: 69px;
    height: 26px;
    font-size: 12px;
    border: 1px solid #589ff9;
    line-height: 26px;
    color: #589ff9;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /deep/ .el-input__inner {
    height: 26px;
    line-height: 26px;
    cursor: pointer;
    font-size: 12px;
    padding-left: 10px;
    border: 1px solid #888a8f;
    margin-left: -4px;
  }

  /deep/ .el-input__icon {
    line-height: 0px;
  }
}

.view_box {
  display: flex;
  justify-content: end;

  .el-dropdown {
    margin-top: 8px;
    margin-right: 10px
  }

  span {
    border: 1px solid #e5e5e5;
    padding: 5px 20px;
    margin-top: 10px;
    border-radius: 3px;
  }
}


.table_one {
  display: flex;

}

.table_two {
  background: #e9e9e9;
  margin: 10px 0;
  border-collapse: collapse;
}

.order {
  width: 150px;

  tr {
    display: flex;
    border: none;
    background: #e9e9e9 !important;
  }

  td {
    width: 33px;

  }

  th:nth-child(1) {
    width: 161px;
    font-size: 12px;
    height: 30px;
    line-height: 30px;

  }

  th {
    width: 105px;
    border: 1px solid #8d888869;
    height: 30px;
    line-height: 30px;
  }
}


tbody {
  tr {
    display: flex;

  }

  td {
    width: 105px;
    white-space: nowrap;
    overflow: hidden;
    border: 1px solid #8d888869;
    line-height: 25px;
    background-color: #fff;
    border-top: none !important;
  }

  td:nth-child(1) {
    width: 161px;
    font-size: 14px;
    height: 30px;
    line-height: 30px;
    text-align: left;
    text-indent: 1em;
    color: #000;
    background-color: #dde1ee;
  }
}

.one {
  line-height: 25px;
  background-color: #e6f5ef;
}

/deep/ .el-icon-date:before {
  content: '',
}


</style>


<style>
.el-tooltip__popper.is-dark {
  background-color: #589ff9 !important;
}

.el-tooltip__popper .popper__arrow {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/src/salary_management/Annual_department/index.vue